/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { ReactNode } from "react";

import { ButtonSizes } from "../types";

interface IconLeftButtonProps {
  title: string;
  icon: ReactNode;
  size: ButtonSizes;
}

const IconLeftButton = ({ title, icon, size }: IconLeftButtonProps) => {
  return (
    <span
      css={css({
        display: "flex",
        alignItems: "center",
        gap: size === "tiny" ? "4px" : "8px"
      })}
    >
      <span
        css={css({
          display: "flex",
          alignItems: "center",
          flexShrink: 0
        })}
      >
        {icon}
      </span>
      {title}
    </span>
  );
};

export default IconLeftButton;
